var _defs, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 50,
    viewBox: "0 0 28 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#040404;}.b{fill:#888;}.c{opacity:0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28,
    height: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 -92)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 28,
    height: 1,
    transform: "translate(-45 110)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 28,
    height: 1,
    transform: "translate(-45 123)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(45 -91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H27.372V.912H0Z",
    transform: "translate(-40.355 106) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.1,1.258H27.471v.912H.1Z",
    transform: "translate(-41.96 124.535) rotate(-45)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobile-menu.f226bf58692271bbc1629067b68170df.svg";
export { ForwardRef as ReactComponent };